// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e5fe9c4","732":"40bdb01d","977":"9c325964"}[chunkId] + ".chunk.js";
};